export default "__VITE_ASSET__DpLEi$bb__"